import type { EvolutionPrediction } from '../../api/client';

const TYPE_LABEL: Record<EvolutionPrediction['prediction_type'], string> = {
  type_1_internal_trend_break: 'TYPE 1',
  type_2_structural_propagation: 'TYPE 2',
  type_3_exogenous_early_warning: 'TYPE 3',
};

export default function PredictionBadge({ prediction }: { prediction: EvolutionPrediction }) {
  return (
    <span className="row" style={{ gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
      <span className="tag blue" title={prediction.model_ref.model_id}>{TYPE_LABEL[prediction.prediction_type]}</span>
      <span className="small faint">{prediction.model_ref.validation_status}</span>
    </span>
  );
}
